import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRouteGuard({ isAllowed, redirectPath = "/login" }) {
  // Replace with your actual auth check (localStorage, cookie, context, etc.)
  if (!isAllowed) return <Navigate to={redirectPath} replace />;
  return <Outlet />;
}